import React from 'react'
import Story from './story'
import DescriptionThumbnail from '../DescriptionThumbnail';

class ProductStory extends Story {
  constructor(props) {
    super(props);

    this.state = {
      story: props.story,
      entity: props.story.entity,
      payload: props.story.payload,
      project: props.story.payload[0],
    }
  }

  render() {
    const company = this.state.entity;
    const project = this.state.project;
    const caption = this.captionWithEntity(I18n.t('jslibrary.stream.company_in_project', {
      company: company.name,
      project: project.title,
      url: project.url,
    }), company);

    return (
      <div className="afd-story" data-insights-category="myad-feed" data-insights-label="product-story" data-insights-value={project.url}>
        <p className="afd-story__caption">{caption}</p>
        <DescriptionThumbnail title={project.title} link={project.url} thumbnail={project.image}/>
      </div>
    )
  }
}

export default ProductStory;